import React from 'react';

import { ApplicantTypes } from 'interfaces/userApplication/userApplication';
const { retailTrialPeriodDays } = require('buyside/util/constantsFromRails.json');
import Link from '../../Link/link';

export const initialValues = {
  acceptedDisclaimer: false,
  applicantType: null,
  basicEmployerName: null,
  basicInvestorType: null,
  city: null,
  degree: null,
  email: '',
  employerAumRange: null,
  employerFundType: null,
  employerName: null,
  employmentStatus: null,
  expectedGraduation: null,
  fieldOfStudy: null,
  firstName: null,
  investorType: null,
  isAccredited: false,
  lastName: null,
  linkedinUrl: null,
  phone: null,
  resume: null,
  schoolName: null,
  title: null,
  yearStart: null
};

export const buysideDisclaimer =
  'By using SumZero and/or becoming a member of SumZero you confirm and represent that you are at least eighteen (18) years of age or older and you are a professional investor on the "buyside" of the market (or a former industry professional currently in between positions) with a sophisticated knowledge of investment markets, an understanding of the risks of investing, an understanding that any content on SumZero is not an investment solicitation by the author or the author’s fund, and an understanding of the limitations of SumZero (please refer to the Terms of Use), or a compliance or legal professional employed by such professional investors.';

export const allocatorDisclaimer: React.ReactElement = (
  <>
    I represent that I am an Accredited Investor or am a duly authorized agent or representative of
    an Accredited Investor as defined by{' '}
    <Link to="https://www.sec.gov/node/172921" target="_blank">
      sections 501 of the Securities Act of 1933.
    </Link>
  </>
);

export const retailDisclaimer =
  'By using SumZero you certify that you have an understanding of the risks of investing, an understanding that any content on SumZero is not an investment solicitation by the author or the author’s fund, and an understanding of the limitations of SumZero, or a compliance or legal professional employed by such professional investors.';

export const successPageHeading = (type: ApplicantTypes, isRetailApproved: boolean): string => {
  if (type === ApplicantTypes.pro) {
    return 'Application Submitted';
  } else if (type === ApplicantTypes.basic) {
    return isRetailApproved ? 'Welcome to SumZero' : 'Application Submitted';
  } else {
    return '';
  }
};

export const successPageMessage = (type: ApplicantTypes, isRetailApproved: boolean): string => {
  if (type === ApplicantTypes.pro) {
    return 'Thank you for applying to SumZero. Your application will be reviewed by a SumZero administrator and you will receive a response shortly.';
  } else if (type === ApplicantTypes.basic) {
    return isRetailApproved
      ? `Congratulations on joining the SumZero network. You will soon receive an email
    containing a link to start your free ${retailTrialPeriodDays}-day trial, providing you
    direct access to fundamental-driven investment reports written by some of the world’s
    top fund managers.`
      : 'Thank you for applying to SumZero. Your application will be reviewed by a SumZero administrator. If approved, you will receive an email containing a link to activate your membership.';
  } else {
    return '';
  }
};
